import { getStore, FolderTreeData } from 'owa-folders';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

/**
 * Selector for getting all shared folders mailbox data
 */
export function getAllSharedFoldersData(userIdentity?: string): FolderTreeData[] {
    if (!userIdentity) {
        userIdentity = getDefaultLogonEmailAddress();
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (14,63): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    // @ts-expect-error
    const mailboxStore = getStore().mailboxFolderTreeData.get(userIdentity);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (18,35): Object is possibly 'undefined'.
    // @ts-expect-error
    const allSharedFolderEmails = mailboxStore.sharedFolderUserEmails;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (22,5): Type '(FolderTreeData | undefined)[]' is not assignable to type 'FolderTreeData[]'.
    // @ts-expect-error
    return allSharedFolderEmails.map(sharedFolderEmail =>
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (26,9): Object is possibly 'undefined'.
        // @ts-expect-error
        mailboxStore.folderTreeTable.get(sharedFolderEmail)
    );
}
